import React from "react"

const ErrorIcon = () => {
  return (
    <svg width="36" height="45" viewBox="0 0 36 45" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.67 33L23.33 29L18 33L12.67 29L7.33 33L0 27.5V38.25C0.00264509 40.0394 0.714653 41.7548 1.97995 43.0201C3.24525 44.2853 4.9606 44.9974 6.75 45H29.25C31.0394 44.9974 32.7548 44.2853 34.0201 43.0201C35.2853 41.7548 35.9974 40.0394 36 38.25V27.5L31.5 30.88L28.67 33ZM30.84 39.84C30.4184 40.2621 29.8465 40.4995 29.25 40.5H6.75C6.15326 40.5 5.58097 40.2629 5.15901 39.841C4.73705 39.419 4.5 38.8467 4.5 38.25V35.87L7.33 38L12.67 34L18 38L23.33 34L28.67 38L31.5 35.87V38.25C31.4995 38.8465 31.2621 39.4184 30.84 39.84Z"
        fill="#BF3131"
      />
      <path
        d="M35.86 15.01V14.8C35.7544 14.569 35.6126 14.3563 35.44 14.17L21.94 0.67C21.7511 0.500675 21.539 0.359243 21.31 0.25H21.1C20.8732 0.116581 20.6213 0.0314683 20.36 0H6.75C4.9606 0.00264509 3.24525 0.714653 1.97995 1.97995C0.714653 3.24525 0.00264509 4.9606 0 6.75V23.5L4.5 26.87L7.33 29L12.67 25L18 29L23.33 25L28.67 29L36 23.5V15.61C35.9784 15.405 35.9313 15.2034 35.86 15.01ZM22.5 7.67L28.33 13.5H24.75C24.1533 13.5 23.581 13.2629 23.159 12.841C22.7371 12.419 22.5 11.8467 22.5 11.25V7.67ZM23.33 20L18 24L12.67 20L7.33 24L4.5 21.87V6.75C4.5 6.15326 4.73705 5.58097 5.15901 5.15901C5.58097 4.73705 6.15326 4.5 6.75 4.5H18V11.25C18.0026 13.0394 18.7147 14.7548 19.9799 16.0201C21.2452 17.2853 22.9606 17.9974 24.75 18H31.5V21.87L28.67 24L23.33 20Z"
        fill="#BF3131"
      />
    </svg>
  )
}

export default ErrorIcon
